const LoanApplicationDocumentsTestIdsScope = {
  ASSOCIATIONS_FORM: 'associations-form',
  LOAN_APPLICATION_DOCUMENTS: 'loan-application-documents',
};

export const LoanApplicationDocumentsTestIds = {
  // LoanApplicationDocuments (drawers)
  BATCH_INTAKE_DRAWER: `${LoanApplicationDocumentsTestIdsScope.LOAN_APPLICATION_DOCUMENTS}.batch-intake-drawer`,
  REVIEW_INTAKE_DRAWER: `${LoanApplicationDocumentsTestIdsScope.LOAN_APPLICATION_DOCUMENTS}.review-intake-drawer`,

  // DocumentItem
  DOCUMENT_LIST_ITEM: `${LoanApplicationDocumentsTestIdsScope.LOAN_APPLICATION_DOCUMENTS}.document-list-item`,
  getDocumentSelectCheckboxId: id =>
    `${LoanApplicationDocumentsTestIdsScope.LOAN_APPLICATION_DOCUMENTS}.select-document-${id}`,

  // DocumentTypeItem
  ASSOCIATIONS_FORM_TYPES_COUNTER: `${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}.types-counter`,

  // EditDocumentAssociationsForm
  ASSOCIATIONS_FORM: `${LoanApplicationDocumentsTestIdsScope.LOAN_APPLICATION_DOCUMENTS}.${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}`,
  ASSOCIATIONS_FORM_DOCUMENT_ASSOCIATIONS_SAVE_BUTTON: `${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}.save-button`,

  // EditExtractionFieldsResultsForm
  EXTRACTION_FIELDS_FORM_SAVE_BUTTON: 'extraction-fields-form.save-button',

  // GenerateBundleFormTab
  ASSOCIATIONS_FORM_IGNORE_MISSING_DOCUMENTS_CHECKBOX: `${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}.ignore-missing-documents-checkbox`,
  ASSOCIATIONS_FORM_SEPARATE_FILES_CHECKBOX: `${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}.separate-files-checkbox`,

  // Dynamic
  getDocumentPagesCountId: pagesCount => `document.pages-count-${pagesCount}`,
  getItemContainerId: id => `item-container.${id}`,
  getListItemTypeId: id => `list-item-type.${id}`,
  getMissingDocumentUploadId: documentTypeId => `missing-document.upload-${documentTypeId}`,

  // GenerateBundleFormTab (inline)
  ASSOCIATIONS_FORM_BUNDLES_DROPDOWN_SELECT: `${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}.bundles-dropdown-select`,
  ASSOCIATIONS_FORM_BUNDLES_OPTION: `${LoanApplicationDocumentsTestIdsScope.ASSOCIATIONS_FORM}.bundles-option`,
};
